module.exports = __webpack_public_path__ + "images/icons/icon-sheild-6d5358b2.svg";